module.exports = __webpack_public_path__ + "static/media/kornferry.5be0491d.jpg";